import { render } from "./apprPlan.vue?vue&type=template&id=d97a8c28"
import script from "./apprPlan.vue?vue&type=script&lang=js"
export * from "./apprPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__